import { FC, HTMLAttributes } from 'react';
import { Flex } from 'antd';
import clsx from 'clsx';

import { Logout, NavMenu, ToggleButton } from './components';

import styles from './styles.module.scss';

import { useSidebarContext } from '@/contexts/sidebar';
import { Logo } from '@/widgets/logo';

export const Sidebar: FC<HTMLAttributes<HTMLElement>> = (props) => {
    const { collapsed } = useSidebarContext();

    return (
        <aside {...props} className={clsx(props.className, { collapsed })}>
            <Flex gap="var(--spacing-lg)" vertical className={styles.container}>
                <Logo />
                <NavMenu />
                <Logout />
                <ToggleButton />
            </Flex>
        </aside>
    );
};
